import React from "react";

import { Country } from "../../features/auth/store/types/country-types";

type CountryTableProps = {
  items: Country[];
  loading?: boolean;
  onEdit?: (item: Country) => void;
  onDelete?: (item: Country) => void;
};

export const CountryTable: React.FC<CountryTableProps> = ({
  items,
  loading,
  onEdit,
  onDelete,
}) => {
  const hasItems = items && items.length > 0;

  return (
    <div className="overflow-x-auto bg-white rounded-lg border border-gray-200">
      <table className="min-w-full text-left">
        <thead className="bg-gray-50 text-xs uppercase text-gray-500">
          <tr>
            <th className="px-4 py-3 font-semibold">Name</th>
            <th className="px-4 py-3 font-semibold">Country Code</th>
            <th className="px-4 py-3 font-semibold">Currency</th>
            <th className="px-4 py-3 font-semibold text-right">Actions</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {loading ? (
            <tr>
              <td colSpan={4} className="px-4 py-6 text-center">
                <div className="flex items-center justify-center h-full">
                  <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-500"></div>
                </div>
              </td>
            </tr>
          ) : hasItems ? (
            items.map((country) => (
              <tr key={country.id} className="text-sm text-gray-800">
                <td className="px-4 py-3">{country.name}</td>
                <td className="px-4 py-3 font-semibold">{country.symbol}</td>
                <td className="px-4 py-3">
                  {country.currency?.name || country.currency?.symbol || "-"}
                </td>
                <td className="px-4 py-3 text-right">
                  <div className="flex items-center justify-end gap-2">
                    <button
                      className="px-3 py-1 rounded bg-yellow-50 text-yellow-700 border border-yellow-200"
                      onClick={() => onEdit?.(country)}
                    >
                      Edit
                    </button>
                    <button
                      className="px-3 py-1 rounded bg-red-50 text-red-700 border border-red-200"
                      onClick={() => onDelete?.(country)}
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={4}
                className="px-4 py-6 text-center text-sm text-gray-500"
              >
                No countries available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
